import { useCallback, useEffect, useRef, useState } from 'react';
import { getOrganizations, invalidateOrganizations, onOrganizationsLoaded } from './organizations';

const IDLE = 'idle';
const LOADING = 'loading';
const LOADED = 'loaded';
const FAILED = 'failed';

export function useOrganizations() {
    const [organizations, setOrganizations] = useState([]);
    const [status, setStatus] = useState(IDLE);
    const fetchedRef = useRef(false);

    const load = useCallback(() => {
        if (fetchedRef.current) {
            return;
        }
        fetchedRef.current = true;
        setStatus(LOADING);
        getOrganizations()
            .then(loaded => {
                setOrganizations(loaded);
                setStatus(LOADED);
            })
            .catch(() => {
                fetchedRef.current = false;
                setStatus(FAILED);
            });
    }, []);

    const retry = useCallback(() => {
        invalidateOrganizations();
        fetchedRef.current = false;
        load();
    }, [load]);

    useEffect(
        () =>
            onOrganizationsLoaded(loaded => {
                setOrganizations(loaded);
                setStatus(LOADED);
            }),
        []
    );

    return {
        organizations,
        loading: status === LOADING,
        loaded: status === LOADED,
        loadFailed: status === FAILED,
        load,
        retry,
    };
}
